import React from 'react';
export function FooterLogo() {
  return <div className="flex items-center gap-3" data-id="element-129">
      {/* Roof Emblem SVG */}
      <svg width="48" height="48" viewBox="0 0 200 120" fill="none" xmlns="http://www.w3.org/2000/svg" className="shrink-0" data-id="element-130">
        {/* Red Roof Triangle */}
        <path d="M100 20 L160 80 L120 80 L100 60 L80 80 L40 80 Z" fill="#BF0A30" data-id="element-131" />
        {/* Navy Block */}
        <rect x="85" y="20" width="30" height="60" fill="#002868" data-id="element-132" />
        {/* White Star */}
        <path d="M100 45 L103 52 L110 52 L105 57 L107 64 L100 60 L93 64 L95 57 L90 52 L97 52 Z" fill="#FFFFFF" data-id="element-133" />
        {/* Red Bottom Bar */}
        <path d="M20 95 L180 95 L170 105 L20 105 Z" fill="#BF0A30" data-id="element-134" />
      </svg>

      {/* Wordmark */}
      <div className="flex flex-col" data-id="element-135">
        <span className="text-white font-heading font-bold text-xl leading-none tracking-tight" data-id="element-136">
          TEXAS DIRECT
        </span>
        <span className="text-white/80 font-sans text-[10px] leading-tight tracking-[0.2em] mt-1" data-id="element-137">
          ROOFING & CONSTRUCTION
        </span>
      </div>
    </div>;
}